import React, { FC } from 'react';
import classes from './Button.module.scss';
import classNames from 'classnames';

const Button: FC<ButtonProps> = (props) => {
  const isDisabled = props.disabled || props.loading;

  const btnClasses = classNames(classes.bg, {
    [classes.disabled]: isDisabled,
    [classes.secondary]: props.secondary,
    [classes.primary]: props.primary,
    [classes.small]: props.small,
    [classes.toggled]: props.toggled
  });

  const onClick = () => {
    if (!isDisabled) props.onClick();
  };

  return (
    <div className={btnClasses} onClick={onClick}>
      {props.children}
    </div>
  );
};

interface ButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  primary?: boolean;
  secondary?: boolean;
  small?: boolean;
  toggled?: boolean;
}

export default Button;
